export default "__VITE_ASSET__YNBtLHei__"